import {FRBase} from "#Formulas/FormulaCore/FRBase";
import {FormDataRetriever} from "#Formulas/FormulaCore/FormDataRetriever";
import {FRFactory} from "#Formulas/FormulaCore/FRFactory";


export class FRFixed extends FRBase{
    public Id:string;

    constructor(Options: any, Parent: FRBase) {
        super(Options, Parent);
        this.Id=this.Options.Id;
    }

    Parse() {
        return ((this.Retriever as FormDataRetriever).Container).ParseFixedField(this.Id,this.Options?.Op,(this.Retriever as any).FieldContainer);
    }

}

FRFactory.AddField('RNFX',FRFixed);